const BoxTag = (props: any) => {
  let color = props.color ?? "rgb(95, 181, 235)";
  let label = props.label ?? "";
  return (
    <span style={{ background: color }} className="Tag">{label}</span>
  )
}

export default BoxTag